/*
 * Elveo theme enhancements.
 * 1. Desktop mega menu: the "Our Collection" dropdown renders its second-level
 *    groups (<details>) as always-open columns on desktop.
 * 2. Wishlist header count: reads the Wishlist by Square app's saved items from
 *    localStorage when the shape is recognisable; the bubble stays hidden otherwise.
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');

  /* ------------------------------------------------------------------
     Mega menu columns
     ------------------------------------------------------------------ */
  function syncMegaMenuColumns() {
    /* Desktop: group <details> become always-open columns.
       Mobile: the same groups inside the drawer stay open too, so one tap on
       "Our Collection" reveals every link — no third tap. */
    var groups = document.querySelectorAll(
      '.menu-drawer__dropdown-submenu details, ' +
        '.menu-drawer__submenu .menu-drawer__menu details'
    );
    groups.forEach(function (details) {
      details.setAttribute('open', '');
      details.dataset.elveoPinned = 'true';
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('details[data-elveo-pinned] > summary');
    if (summary) event.preventDefault();
  });

  /* ------------------------------------------------------------------
     Wishlist count
     ------------------------------------------------------------------ */
  function readWishlistCount() {
    var count = null;
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!/wish/i.test(key)) continue;
        var raw = localStorage.getItem(key);
        if (!raw) continue;
        try {
          var data = JSON.parse(raw);
          if (Array.isArray(data)) {
            count = data.length;
          } else if (data && typeof data === 'object') {
            var items = data.items || data.products || data.list || data.wishlist;
            if (Array.isArray(items)) count = items.length;
          }
        } catch (e) {
          /* not JSON — ignore */
        }
        if (count !== null) break;
      }
    } catch (e) {
      /* storage unavailable — leave hidden */
    }
    return count;
  }

  function updateWishlistBubble() {
    var bubbles = document.querySelectorAll('.elveo-wishlist-count');
    if (!bubbles.length) return;
    var count = readWishlistCount();
    bubbles.forEach(function (bubble) {
      if (count === null || count === 0) {
        bubble.hidden = true;
      } else {
        bubble.hidden = false;
        var label = bubble.querySelector('span[aria-hidden]');
        if (label) label.textContent = '(' + count + ')';
      }
    });
  }

  /* ------------------------------------------------------------------
     Scroll reveals — rise + fade once, staggered inside grids
     ------------------------------------------------------------------ */
  function setupReveals() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var singles = document.querySelectorAll(
      '.title--section, .rich-text__blocks, .image-with-text__content, .image-banner__information'
    );
    var grids = document.querySelectorAll(
      '.collections-list, .grid--products, .product-grid, .multicolumn-list'
    );

    var targets = [];
    singles.forEach(function (el) {
      el.classList.add('elveo-reveal');
      targets.push(el);
    });
    grids.forEach(function (grid) {
      var items = grid.querySelectorAll(':scope > li, :scope > .card-wrapper, :scope > .grid__item');
      items.forEach(function (item, i) {
        item.classList.add('elveo-reveal');
        item.style.setProperty('--elveo-reveal-delay', Math.min(i, 8) * 60 + 'ms');
        targets.push(item);
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('elveo-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        /* already in view on load — show without animation jank */
        el.classList.add('elveo-in');
      } else {
        observer.observe(el);
      }
    });
  }

  /* ------------------------------------------------------------------
     Mega menu hover features — hovering a collection link swaps the
     featured tiles to that collection's imagery; leaving restores them
     ------------------------------------------------------------------ */
  function clearMenuFeatures(panel) {
    var wrapper = panel.querySelector('.burger-menu__list-images-wrapper');
    if (!wrapper) return;
    wrapper.classList.remove('elveo-features-on');
    wrapper.querySelectorAll('.elveo-menu-feature').forEach(function (t) {
      t.classList.remove('elveo-feature-active');
    });
  }

  function setupMenuFeatures() {
    document.addEventListener('mouseover', function (event) {
      if (!DESKTOP.matches) return;
      var panel = event.target.closest('.burger-menu__dropdown-wrapper');
      if (!panel) return;
      var link = event.target.closest('.menu-drawer__dropdown-submenu a');
      if (!link) return;
      var wrapper = panel.querySelector('.burger-menu__list-images-wrapper');
      if (!wrapper) return;
      var href = link.getAttribute('href');
      var match = null;
      var tiles = wrapper.querySelectorAll('.elveo-menu-feature');
      tiles.forEach(function (t) {
        if (t.dataset.elveoFor === href) match = t;
      });
      if (match) {
        tiles.forEach(function (t) {
          t.classList.toggle('elveo-feature-active', t === match);
        });
        wrapper.classList.add('elveo-features-on');
      } else {
        clearMenuFeatures(panel);
      }
    });

    document.querySelectorAll('.burger-menu__dropdown-wrapper').forEach(function (panel) {
      panel.addEventListener('mouseleave', function () {
        clearMenuFeatures(panel);
      });
    });

    /* fresh open always starts from the default product tiles */
    document.querySelectorAll('.burger-menu__hover--open-btn').forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        var menu = trigger.closest('burger-menu');
        var panel = menu && menu.querySelector('.burger-menu__dropdown-wrapper');
        if (panel) clearMenuFeatures(panel);
      });
    });
  }

  function init() {
    syncMegaMenuColumns();
    updateWishlistBubble();
    setupReveals();
    setupMenuFeatures();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  DESKTOP.addEventListener('change', syncMegaMenuColumns);
  window.addEventListener('storage', updateWishlistBubble);
  /* The app mutates storage after add/remove clicks; refresh shortly after. */
  document.addEventListener('click', function () {
    setTimeout(updateWishlistBubble, 600);
  });
})();
